<template>
  <div>
    <div
      class="text-h3 font-medium"
      :class="$store.state.mobile ? '' : 'mt-4 mb-4 d-flex align-center'"
    >
      <div
        class="d-inline-flex align-center cursor-pointer"
        @click="$router.back()"
      >
        <v-icon
          size="24"
          color="#666"
          class="me-2"
        >
          mdi-arrow-left
        </v-icon><template v-if="$store.getters.languageGetter === '1'">
          تفاصيل الطلب
        </template>
        <template v-else>
          Order Detail
        </template>
      </div>
    </div>
    <div v-if="loading">
      <v-skeleton-loader
        type="heading"
        class="mb-4"
      />
      <v-skeleton-loader
        type="image"
        class="mb-4"
        height="120"
      />
      <v-skeleton-loader
        class="mb-4"
        type="article"
      />
      <div class="text-right d-flex justify-end">
        <v-skeleton-loader
          type="button"
        />
      </div>
    </div>
    <div
      v-else
    >
      <div class="mb-4 d-flex text-h3">
        <template v-if="$store.getters.languageGetter === '1'">
          رقم الطلب
        </template>
        <template v-else>
          Order No.
        </template>{{ order.orderNo }}
        <v-spacer />
        {{ order.dStatus | statusFilter($store.getters.languageGetter) }}
      </div>
      <v-card
        color="grey lighten-5"
        flat
        class="pb-4 mb-6"
        :class="$store.state.mobile ? 'pa-4' : 'px-6 pt-6 '"
      >
        <div class="white rounded-pill">
          <v-progress-linear
            class="rounded-pill"
            :value="step"
            color="success"
            height="24"
          >
            <v-row
              no-gutters
              class="text-center body-2"
            >
              <v-col
                cols="3"
                class="white--text"
              >
                {{ order.createTime ? order.createTime.substr(0,10) : '' }}
              </v-col>
              <v-col
                cols="3"
                :class="order.dStatus === '5' ? 'white--text' : 'grey--text'"
              >
                {{ order.checkTime ? order.checkTime.substr(0, 10) : '' }}
              </v-col>
              <v-col
                cols="3"
                :class="order.dStatus === '8' ? 'white--text' : 'grey--text'"
              >
                {{ order.deliveryTime ? order.deliveryTime.substr(0, 10) : '' }}
              </v-col>
              <v-col
                cols="3"
                :class="order.dStatus === '10' ? 'white--text' : 'grey--text'"
              >
                {{ order.completeTime ? order.completeTime.substr(0, 10) : '' }}
              </v-col>
            </v-row>
          </v-progress-linear>
        </div>
        <v-row
          no-gutters
          class="text-center pt-2"
        >
          <v-col
            cols="3"
          >
            <template v-if="$store.getters.languageGetter === '1'">
              انتظار الدفع
            </template>
            <template v-else>
              Awaiting Payment
            </template>
          </v-col>
          <v-col cols="3">
            <template v-if="$store.getters.languageGetter === '1'">
              بانتظار الشحن
            </template>
            <template v-else>
              Awaiting Shipping
            </template>
          </v-col>
          <v-col cols="3">
            <template v-if="$store.getters.languageGetter === '1'">
              تم شحن الشحنة
            </template>
            <template v-else>
              Shipment Shipped
            </template>
          </v-col>
          <v-col cols="3">
            <template v-if="$store.getters.languageGetter === '1'">
              الواردة
            </template>
            <template v-else>
              Received
            </template>
          </v-col>
        </v-row>
      </v-card>
      <div class="mb-2 text-h3">
        <template v-if="$store.getters.languageGetter === '1'">
          معلومات قائمة الشراء
        </template>
        <template v-else>
          Order Information
        </template>
      </div>
      <v-card
        flat
        color="grey lighten-5"
        class="mb-6"
      >
        <v-divider />
        <v-container
          class="px-0"
          :class="$store.state.mobile ? 'py-0' : ''"
        >
          <v-row
            align="stretch"
            no-gutters
          >
            <v-col
              :cols="$store.state.mobile ? 12 : 9"
              class="white"
            >
              <v-row
                class="px-2"
              >
                <v-col
                  :cols="$store.state.mobile ? 5 : 3"
                  class="grey--text"
                >
                  <template v-if="$store.getters.languageGetter === '1'">
                    تاريخ الطلب:
                  </template>
                  <template v-else>
                    Order Date:
                  </template>
                </v-col>
                <v-col :cols="$store.state.mobile ? 7 : 9">
                  {{ order.createTime ? order.createTime.substr(0,10) : '' }}
                </v-col>
              </v-row>
              <v-row
                class="px-2"
              >
                <v-col
                  :cols="$store.state.mobile ? 5 : 3"
                  class="grey--text"
                >
                  <template v-if="$store.getters.languageGetter === '1'">
                    طريقة الدفع او السداد:
                  </template>
                  <template v-else>
                    Payment Method:
                  </template>
                </v-col>
                <v-col :cols="$store.state.mobile ? 7 : 9">
                  {{ order.payType === '1' ? 'Paypal' : $store.getters.languageGetter === '1' ? 'دفع متواجد حاليا' : 'Offline' }}
                </v-col>
              </v-row>
              <v-row
                class="px-2"
              >
                <v-col
                  :cols="$store.state.mobile ? 5 : 3"
                  class="grey--text"
                >
                  <template v-if="$store.getters.languageGetter === '1'">
                    عنوان الشحن
                  </template>
                  <template v-else>
                    Shipped to:
                  </template>
                </v-col>
                <v-col :cols="$store.state.mobile ? 7 : 9">
                  {{ order.countryName }}({{ order.countryNameEn }}){{ order.addr }}
                </v-col>
              </v-row>
              <v-row
                class="px-2"
              >
                <v-col
                  :cols="$store.state.mobile ? 5 : 3"
                  class="grey--text"
                >
                  <template v-if="$store.getters.languageGetter === '1'">
                    المرفق
                  </template>
                  <template v-else>
                    Attachment
                  </template>
                </v-col>
                <v-col :cols="$store.state.mobile ? 7 : 9">
                  <a
                    v-if="annexUrl"
                    :href="annexUrl"
                    style="color:#03a9f4"
                  >
                    <template v-if="$store.getters.languageGetter === '1'">
                      تحميل
                    </template>
                    <template v-else>
                      Download
                    </template>
                  </a>
                </v-col>
              </v-row>
              <!-- <v-row
                class="px-2"
              >
                <v-col
                  :cols="$store.state.mobile ? 5 : 3"
                  class="grey--text"
                >
                  <template v-if="$store.getters.languageGetter === '1'">
                    رقم بوليصة الشحن
                  </template>
                  <template v-else>
                    Waybill number
                  </template>
                </v-col>
                <v-col :cols="$store.state.mobile ? 7 : 9">
                  {{ order.wayBillNo }}
                </v-col>
              </v-row> -->
            </v-col>
            <v-col
              :cols="$store.state.mobile ? 12 : 3"
              class="px-4"
            >
              <v-row
                class="font-medium"
                align="baseline"
                no-gutters
              >
                <v-col
                  cols="auto"
                  class="text-h4"
                >
                  <template v-if="$store.getters.languageGetter === '1'">
                    السعر الإجمالي للبضائع:
                  </template>
                  <template v-else>
                    Grand Total:
                  </template>
                </v-col>
                <v-spacer />
                <v-col
                  cols="auto"
                  class="error--text text-h2"
                >
                  {{ order.currency }}{{ order.actualAmount }}
                </v-col>
              </v-row>
              <pay-pal
                v-if="order.dStatus === '1' && order.payType !== '2'"
                :amount="order.actualAmount"
                currency="USD"
                :client="credentials"
                :button-style="{size: 'large', shape: 'rect'}"
                env="production"
                @payment-completed="paymentCompleted"
                @payment-cancelled="paymentCancelled"
              />
              <v-btn
                v-if="order.dStatus === '1'"
                text
                :outlined="order.payType === '2'"
                block
                light
                class="grey--text text--darken-1 my-2"
                @click="show = true"
              >
                <template v-if="$store.getters.languageGetter === '1'">
                  الغاء الطلب
                </template>
                <template v-else>
                  Cancel Order
                </template>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
        <v-divider />
      </v-card>
      <div class="mb-2 text-h3">
        <template v-if="$store.getters.languageGetter === '1'">
          ملخص الطلب
        </template>
        <template v-else>
          Order Summary
        </template>
      </div>
      <v-card outlined>
        <v-card-title class="grey lighten-5">
          <div class="text-h4">
            <template v-if="$store.getters.languageGetter === '1'">
              عدد شحنة
            </template>
            <template v-else>
              Shipping Shipment
            </template>
          </div>
          <v-spacer />
          <div>{{ +order.dStatus > 8 ? 'Shipment Shipped' : 'Awaiting Shipping' }}</div>
          <div class="col-12 py-0" />
          <div class="col-12 py-0" />
          <div class="body-1 grey--text text--darken-2">
            <template v-if="$store.getters.languageGetter === '1'">
              تكلفة الشحن: مجاني
            </template>
            <template v-else>
              Shipping Cost:  Free
            </template>
          </div>
        </v-card-title>
        <div
          v-if="$store.state.mobile"
          class="pa-2"
        >
          <div
            v-for="(detail,i) in order.detail"
            :key="detail.goodDetailId"
          >
            <div class="d-flex">
              <div class="pe-2">
                <router-link :to="{name: 'GoodsDetail', params: {id: detail.goodId}}">
                  <v-img
                    :src="detail.specImage ? detail.specImage + '?x-oss-process=image/resize,m_mfit,w_200,h_200' : detail.image + '?x-oss-process=image/resize,m_mfit,w_200,h_200'"
                    width="80"
                    height="80"
                    class="grey lighten-5"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey"
                        />
                      </v-row>
                    </template>
                  </v-img>
                </router-link>
              </div>
              <div>
                <div class="mb-2 line-break">
                  {{ $store.getters.languageGetter === '1' ? detail.goodName : detail.goodNameEn }}
                </div>
                <div class="grey--text body-2">
                  {{ $store.getters.languageGetter === '1' ? detail.goodDetailName : detail.goodDetailNameEn }}
                </div>
              </div>
              <div class="text-right ps-4 ms-auto">
                <div class="mb-2 error--text">
                  {{ order.currency }}{{ detail.price }}
                </div>
                <div class="grey--text">
                  x{{ detail.buNumber }}
                </div>
              </div>
            </div>
            <v-divider
              v-if="i < order.detail.length - 1"
              class="my-2"
            />
          </div>
        </div>
        <v-data-table
          v-else
          :headers="headers"
          :items="order.detail"
          item-key="goodDetailId"
          class="data-table-with-select"
          no-data-text="Nothing here"
          loading-text="Loading..."
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item.item="{item}">
            <div
              class="py-3 d-flex"
              style="max-width:500px"
            >
              <div>
                <v-img
                  :src="item.specImage ? item.specImage + '?x-oss-process=image/resize,m_mfit,w_200,h_200' : item.image + '?x-oss-process=image/resize,m_mfit,w_200,h_200'"
                  width="80"
                  height="80"
                  aspect-ratio="1"
                  contain
                  class="grey lighten-5"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey"
                      />
                    </v-row>
                  </template>
                </v-img>
              </div>
              <div class="ps-3">
                <div class="mb-2 line-break line-height-sm black--text">
                  {{ $store.getters.languageGetter === '1' ? item.goodName : item.goodNameEn }}
                </div>
                <div class="grey--text">
                  {{ item.goodNo }}
                </div>
                <div class="grey--text">
                  {{ $store.getters.languageGetter === '1' ? item.goodDetailName : item.goodDetailNameEn }}
                </div>
              </div>
            </div>
          </template>
          <template v-slot:item.price="{item}">
            <span class="error--text">{{ order.currency }}{{ item.price }}</span>
          </template>
          <template v-slot:item.summary="{item}">
            <span class="error--text">{{ order.currency }}{{ (+item.price * +item.goodNumber).toFixed(2) }}</span>
          </template>
        </v-data-table>
      </v-card>
      <div
        v-if="shippingList.length"
        class="mb-2 mt-6 text-h3"
      >
        <template v-if="$store.getters.languageGetter === '1'">
          عدد شحنة
        </template>
        <template v-else>
          Order Shipment
        </template>
      </div>
      <v-card
        v-if="shippingList.length"
        outlined
      >
        <v-card-title>
          <template v-if="$store.getters.languageGetter === '1'">
            لديك {{ shippingList.length }} شحنة
          </template>
          <template v-else>
            You have {{ shippingList.length }} shipment
          </template>
        </v-card-title>
        <v-card-text>
          <div
            v-for="shipping in shippingList"
            :key="shipping.id"
          >
            <template v-if="$store.getters.languageGetter === '1'">
              أرقام التتبع:
            </template>
            <template v-else>
              Tracking numbers:
            </template> {{ shipping.wayBillNo }}
          </div>
        </v-card-text>
      </v-card>
    </div>
    <v-dialog
      v-model="show"
      max-width="400"
    >
      <v-card>
        <v-card-title class="pe-2">
          <v-spacer />
          <v-btn
            icon
            @click="show = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-8 px-4 headline black--text d-flex align-center">
          <v-icon
            size="48"
            color="#f1c054"
            class="me-2"
          >
            mdi-information
          </v-icon>
          <template v-if="$store.getters.languageGetter === '1'">
            هل أنت متأكد من إلغاء هذا الطلب؟
          </template>
          <template v-else>
            Are you sure to cancel this order?
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="grey darken-1"
            text
            outlined
            @click="show = false"
          >
            <template v-if="$store.getters.languageGetter === '1'">
              يلغي
            </template>
            <template v-else>
              Cancel
            </template>
          </v-btn>
          <v-btn
            :loading="cancelling"
            color="#ff9a00"
            depressed
            dark
            @click="cancelOrder"
          >
            <template v-if="$store.getters.languageGetter === '1'">
              يتأكد
            </template>
            <template v-else>
              Confirm
            </template>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { statusFilter } from '@/plugins/filters';
import PayPal from 'vue-paypal-checkout';

export default {
  name: 'UserOrderDetail',
  filters: {
    statusFilter,
  },
  components: {
    PayPal,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      show: false,
      cancelling: false,
      order: {
        detail: [],
      },
      shippingList: [],
      credentials: {
        sandbox: 'AW4ap4sF2EB0SdGs71kxGMU_edUHBq1gUwBtTSLhR5oCyvfMzhP5pqWs8BCG64aEDi-U1BsKBY_4ycHv',
        production: 'Af0nU4EiDcvjRLXjYKs6oO_n_s6b_OD7O9z2rjyA3hX8SQoT00_N0qLLkMNfmyJ553Y27PigbW-qgG-z',
      },
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$store.getters.languageGetter === '1' ? 'بند' : 'Item',
          align: 'start',
          sortable: false,
          value: 'item',
          class: 'text-h6 black--text',
        },
        {
          text: this.$store.getters.languageGetter === '1' ? 'سعر' : 'Price',
          value: 'price',
          sortable: true,
          class: 'text-h6 black--text',
        },
        {
          align: 'center',
          text: this.$store.getters.languageGetter === '1' ? 'كمية' : 'Quantity',
          value: 'goodNumber',
          class: 'text-h6 black--text',
          sortable: true,
        },
        {
          align: 'center',
          text: this.$store.getters.languageGetter === '1' ? 'كمية' : 'Amount',
          value: 'summary',
          class: 'text-h6 black--text',
          sortable: false,
        },
      ];
    },
    step() {
      if (+this.order.dStatus >= 1 && +this.order.dStatus < 5) {
        return 25;
      }
      if (+this.order.dStatus >= 5 && +this.order.dStatus < 8) {
        return 50;
      }
      if (+this.order.dStatus >= 8 && +this.order.dStatus < 10) {
        return 75;
      }
      return 100;
    },
    annexUrl() {
      return this.order.annex ? process.env.VUE_APP_API + this.order.annex : '';
    },
  },
  created() {
    this.loadPageData();
  },
  methods: {
    ...mapActions('center', ['getOrderDetailAsync', 'cancelOrderAsync', 'getShippingListAsync']),
    ...mapActions('cart', ['payNowAsync']),
    loadPageData() {
      this.loading = true;
      this.getShippingListAsync({ orderId: this.id, pagesize: 100 }).then((res) => {
        this.shippingList = res.items;
      });
      this.getOrderDetailAsync({ id: this.id }).then((res) => {
        this.order = res;
      }).finally(() => {
        this.loading = false;
      });
    },
    cancelOrder() {
      this.cancelling = true;
      this.cancelOrderAsync({ id: this.order.id }).then(() => {
        this.loadPageData();
      }).finally(() => {
        this.cancelling = false;
        this.show = false;
      });
    },
    paymentCompleted(data) {
      const params = {
        orderId: this.order.id,
        buyerId: this.$store.state.user.id,
        orderNo: this.order.orderNo,
        amount: this.order.actualAmount,
        createUserName: data.payer.payer_info.email,
        createTime: data.create_time,
        paypalId: data.id,
      };
      this.$store.commit('SET_MINI_LOADING');
      this.payNowAsync(params).then(() => {
        this.$router.replace({ name: 'UserOrderDetail', params: { id: this.order.id } });
      }).finally(() => {
        this.$store.commit('SET_MINI_LOADING');
      });
    },
    paymentCancelled() {
      this.$store.commit(
        'TOGGLE_SNACKBAR',
        {
          type: 'error',
          text: 'Payment Cancelled',
        },
        { root: true },
      );
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
